import CoreBase from '../services/engines/CoreBase';

// local
import formatter from './Formatter';
import percentageCalculator from './PercentageHelper';

let _name = 'BitvavoPriceHelper';
class BitvavoPriceHelper extends CoreBase {
    /**
     * fails when price is negative
     *
     * @param {*} price
     * @returns
     */
    priceRounder = (price, show1000) => {
        try {
            if (show1000 === undefined) show1000 = true;

            if (price > 10000) return formatter.toFixed(price, 0, show1000);
            if (price > 1000) return formatter.toFixed(price, 1, show1000);
            if (price > 100) return formatter.toFixed(price, 2, show1000);
            if (price > 10) return formatter.toFixed(price, 3, show1000);
            if (price > 1) return formatter.toFixed(price, 4, show1000);

            // complex round
            if (price >= 0.0001 && price < 0.001) return price.toFixed(8);
            if (price >= 0.001 && price < 0.01) return price.toFixed(7);
            if (price >= 0.01 && price < 0.1) return price.toFixed(6);
            if (price >= 0 && price < 1) return price.toFixed(5);

            return price;
        } catch (error) {
            this.logError('priceRounder', error.message);
            return null;
        }
    };

    getRounding = (price) => {
        try {
            if (price === undefined || price === null) return 2;

            if (price >= 10000) return 2;
            if (price >= 1000) return 2;
            if (price >= 100) return 3;
            if (price >= 10) return 4;
            if (price >= 1) return 4;
            if (price >= 0) return 5;

            // if (price >= 0.0001 && price < 0.001) return 0.00000001;
            // if (price >= 0.001 && price < 0.01) return 0.0000001;
            // if (price >= 0.01 && price < 0.1) return 0.000001;
            // if (price >= 0 && price < 1) return 0.00001;

            return price;
        } catch (error) {
            this.logError('getRounding', error.message);
            return price;
        }
    };

    getStepsize = (price) => {
        try {
            if (price >= 10000) return 1;
            if (price >= 1000) return 0.1;
            if (price >= 100) return 0.01;
            if (price >= 10) return 0.001;
            if (price >= 1) return 0.0001;

            if (price >= 0.0001 && price < 0.001) return 0.00000001;
            if (price >= 0.001 && price < 0.01) return 0.0000001;
            if (price >= 0.01 && price < 0.1) return 0.000001;
            if (price >= 0 && price < 1) return 0.00001;

            return price;
        } catch (error) {
            this.logError('getStepsize', error.message);

            return price;
        }
    };
}

const bitvavoPriceHelper = new BitvavoPriceHelper();
export default bitvavoPriceHelper;
